import urlJoin from 'url-join';

import { ToastComponent } from '../components/ToastComponent';
import { PermitWebList } from '../permitsList';
import { IDeviceReassignmentDTO, IReassignmentDataToSend, SelectDeviceData } from '../interfaces/interfaceReassignment';
import { CONNREFUSED } from 'dns';

export interface ICoordinates {
  latitude?: number;
  longitude?: number;
}

export const generateUrlBase = (section: string) => {
  const urlEnv = process.env.REACT_APP_SECURITYAPIURI || '';
  const url = urlJoin(urlEnv, section);

  return url;
};

export const generateUrlBasePrepayCards = (section: string) => {
  const urlEnv = process.env.REACT_APP_PREPAYCARDSAPIURI || '';
  const url = urlJoin(urlEnv, section);

  return url;
};

export const generateUrlBaseApiBilling = (section: string) => {
  const urlEnv = process.env.REACT_APP_BILLINGAPIURI || '';
  const url = urlJoin(urlEnv, section);

  return url;
};

export const generateUrlBaseApiConfig = (section: string) => {
  const urlEnv = process.env.REACT_APP_CONFIGURATIONURI || '';
  const url = urlJoin(urlEnv, section);

  return url;
};

export const validateMac = (mac: string) => {
  const regExpLiteral =
    /^[0-9a-f]{1,2}([.:-])[0-9a-f]{1,2}(?:\1[0-9a-f]{1,2}){4}$/gim;
  return mac.match(regExpLiteral);
};

/**
 *Limpia un objeto de acuerdo a las propiedades de una interfaz
 * @param data El objeto que se va limpiar
 * @param interfaz que se necesita
 */
export const createObjectAsInterface = (data: any, interfaz: any): any => {
  const result: any = {};

  for (const key in interfaz) {
    if (interfaz.hasOwnProperty(key) && data.hasOwnProperty(key)) {
      result[key] = data[key];
    }
  }

  return result;
};


export const getCurrentPosition = async (): Promise<ICoordinates> => {
  const messageError = 'Por favor activa la ubicación para continuar.';

  try {
    if (!navigator.geolocation) {
      ToastComponent('warning', 'Error', 'La geolocalización no es soportada por este navegador.');
      throw new Error('La geolocalización no es soportada por este navegador.');
    }

    const permission = await navigator.permissions.query({ name: 'geolocation' as PermissionName });

    if (permission.state === 'denied') {
      ToastComponent('warning', 'Permiso denegado', 'Activa los permisos de ubicación en la configuración del navegador.');
      throw new Error('Permiso de ubicación denegado.');
    }

    return await new Promise<ICoordinates>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          const coords: ICoordinates = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          resolve(coords);
        },
        (error: GeolocationPositionError) => {
          ToastComponent('warning', 'Error', messageError);
          reject(new Error(messageError));
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      );
    });

  } catch (error: any) {
    ToastComponent('warning', 'Error', error.message || messageError);
    throw error;
  }
};

export const eliminarNull = (objet: any) => {
  return JSON.parse(
    JSON.stringify(objet, (clave, valor) => {
      if (valor !== null) {
        return valor;
      }
    })
  );
};

export function validatePermissions(permission: number, isActionValue: boolean = false): boolean {

  const permitsUser = localStorage.getItem(isActionValue ? 'actionValue_user' : 'permitions_user') ?? '0';

  let result = false;


  const int64A = BigInt(permission);
  const int64B = BigInt(parseInt(permitsUser));

  const andPermit = int64A & int64B;

  if (int64A === andPermit) {
    result = true;
  }

  return result;
}



export function deleteDuplicates(arrary: any[], field: string) {
  const uniqueArray = arrary.filter(
    (obj, index, self) =>
      index === self.findIndex(item => item[field] === obj[field])
  );
  return uniqueArray;
}

/**
 *Recibe un array y le da formato de queryParams
 * @param cabecera El titulo del queryParam
 * @param list El listado que vamos a transformar
 * @returns {String} Una cadena con formato de queryParams
 */
export const createQueryParams = (cabecera: string, list: any): any => {
  if (!Array.isArray(list)) {
    return '';
  }

  const queryParams = list
    .map(valor => {
      const encodedValue = encodeURIComponent(valor);
      return `${encodeURIComponent(cabecera)}=${encodedValue}`;
    })
    .join('&');

  return queryParams;
};

/**
 *Valida que el usuario tenga al menos un permiso en la web. Se validan los permisos de lista
 * @param userPermission El permiso del usuario
 */
export function validateUserWebPermission(): boolean {
  for (const iterator of PermitWebList) {
    let res = validatePermissions(iterator);
    if (res === true) {
      return true;
    }
  }
  return false
}

export function formatDateDDMMYY(date: string) {
  let dateFrom = new Date(date)
  const day = String(dateFrom.getDate()).padStart(2, '0');
  const month = String(dateFrom.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
  const year = dateFrom.getFullYear();

  return `${day}-${month}-${year}`;
}

export function formatDateTime(date: string) {
  const d = new Date(date);
  return d.toLocaleString('es-MX', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
}


export function pickFields<T extends object, K extends keyof T>(
  data: T[],
  keys: K[],
  id: K
): Pick<T, K>[] {
  return data
    .filter(item => item[id] !== null && item[id] !== "" && item[id] !== undefined)
    .map(item => {
      const result = {} as Pick<T, K>;
      keys.forEach(key => {
        result[key] = item[key];
      });
      return result;
    });
}


export enum TypeSamEnum {
  /**
   * Inicialización
   * Observaciones: Sistema de inicialización (EPS)
   * Dispositivos válidos: Nuevos SAMS, recargas
   */
  Inicializacion = 0,

  /**
   * Emisión
   * Observaciones: Nuevos SAMS
   */
  Emision = 1,

  /**
   * Emisión de medios precargados
   */
  EmisionMediosPrecargados = 2,

  /**
   * Recarga de Monedero
   */
  RecargaMonedero = 3,

  /**
   * Recarga de Monedero y Crédito
   * Dispositivos válidos: VRT, CET, CAU, POS, Granja de SAMs
   */
  RecargaMonederoCredito = 4,

  /**
   * Recarga de BPD
   * Dispositivos válidos: CAU
   */
  RecargaBPD = 5,

  /**
   * Recarga de Monedero, Crédito y BPD
   * Dispositivos válidos: CAU
   */
  RecargaMonederoCreditoBPD = 6,

  /**
   * Productos
   * Dispositivos válidos: Torniquete, Garita, CET, SAC
   */
  Productos = 7
}


type Device = {
  DeviceTypeEnum: number;
  DeviceTypeName: string;
};

export function filterByDeviceTypeEnum(devices: Device[], enumFilter: number[]): Device[] {
  return devices.filter(device => enumFilter.includes(device.DeviceTypeEnum));
}

// Definir qué tipos de dispositivos se permiten según el tipo SAM
export const getFilteredDeviceTypes = (samType: TypeSamEnum): number[] => {
  switch (samType) {
    case TypeSamEnum.RecargaMonederoCredito:
      return [1, 4, 6, 7, 8];
    case TypeSamEnum.RecargaBPD:
    case TypeSamEnum.RecargaMonedero:
      return [6];
    case TypeSamEnum.Productos:
      return [2, 3, 4, 5];
    default:
      return [];
  }
};

export function extractGroupedUniqueEntries(
  deviceTypeEnum: number,
  reassignmentDeviceData: any[],

): SelectDeviceData {
  const filteredData = reassignmentDeviceData
    .filter(item => item.DeviceTypeEnum === Number(deviceTypeEnum))





  return {
    stations: pickFields(
      filteredData.filter((item, index, self) =>
        index === self.findIndex(i => i.StationId === item.StationId)
      ),
      ['StationName', 'StationId'],
      'StationId'
    ),
    locations: pickFields(
      filteredData,
      ['LocationName', 'LocationId', 'StationId'],
      'LocationId'
    ),
    projects: pickFields(
      filteredData,
      ['ProjectName', 'ProjectId'],
      'ProjectId'
    ),
    routes: pickFields(filteredData, ['RouteName', 'RouteId'], 'RouteId'),
    economicNumbers: pickFields(
      filteredData,
      ['EconomicNumber', 'EconomicNumberId'],
      'EconomicNumberId'
    ),
    pcModules: pickFields(
      filteredData,
      ['PcModuleName', 'PcModuleId'],
      'PcModuleId'
    ),
    socket: pickFields(filteredData, ['SocketId'], 'SocketId'),
    readersIds: pickFields(filteredData.filter((ri: any) => ri.DeviceNumber.trim() !== ''), ['DeviceNumber',
      'DeviceId',], 'DeviceId')
  };
}

export function getCatalogForm(
  deviceTypeEnum: string,
  reassignmentDeviceData: any[],
  valuesForm: IReassignmentDataToSend,
  filterConfig: any[]
): SelectDeviceData {

  const filteredData = reassignmentDeviceData
    .filter(item => item.DeviceTypeEnum === Number(deviceTypeEnum))

  return {
    stations: pickFields(filteredData
      .filter((item, index, self) =>
        index === self.findIndex(i => i.StationId === item.StationId)
      ), ['StationName', 'StationId'], 'StationId'),
    locations: pickFields(filteredData
      .filter((item: IDeviceReassignmentDTO) => item.StationId === valuesForm.stationId)
      .filter((item, index, self) =>
        index === self.findIndex(i => i.LocationId === item.LocationId)
      ), ['LocationName', 'LocationId', 'StationId'], 'LocationId'),
    projects: pickFields(filteredData
      .filter((item: IDeviceReassignmentDTO) => item.LocationId === valuesForm.locationId)
      .filter((item, index, self) =>
        index === self.findIndex(i => i.ProjectId === item.ProjectId)
      ), ['ProjectName', 'ProjectId'], 'ProjectId'),
    routes: pickFields(filteredData, ['RouteName', 'RouteId'], 'RouteId'),
    economicNumbers: pickFields(filteredData, ['EconomicNumber', 'EconomicNumberId'], 'EconomicNumberId'),
    pcModules: pickFields(filteredData, ['PcModuleName', 'PcModuleId'], 'PcModuleId'),
    socket: pickFields(filteredData, ['SocketId'], 'SocketId'),
    readersIds: pickFields(
      filteredData
        .filter((ri: any) => ri.DeviceNumber?.trim() !== '')
        .filter((item: IDeviceReassignmentDTO) => item.ProjectId === valuesForm.projectId)
        .filter((item, index, self) =>
          index === self.findIndex(i => i.DeviceId === item.DeviceId)
        ),
      ['DeviceNumber', 'DeviceId'],
      'DeviceId'
    )
  };
}


export function getSelectedItemsLabel(items: any = [], singularLabel = 'columna', pluralLabel = 'columnas'): string {
  const count = items.length;

  if (count === 0) return `Ningún ${pluralLabel} seleccionado`;
  if (count === 1) return `1 ${singularLabel} seleccionado`;

  return `${count} ${pluralLabel} seleccionados`;
}


